export const WHATSAPP_NUMBER = "5491124834754";

export const WHATSAPP_MESSAGES = {
  default: "¡Hola Guido! Vi tu web y me gustaría consultarte sobre un proyecto",
  hero: "¡Hola Guido! Vi tu web y quiero hablarte sobre mi proyecto",
  projects: "¡Hola Guido! Vi tus proyectos y quiero uno similar para mi negocio",
};

export function buildWhatsAppUrl(message = WHATSAPP_MESSAGES.default) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
